<template>
    <div id="app">
        <div v-if="isAuthenticated">
            <AppHeader/>
            <main class="app-main">
                <div class="">
                    <keep-alive>
                        <transition name="fade" mode="out-in">
                            <router-view class="view"></router-view>
                        </transition>
                    </keep-alive>
                </div>
            </main>
            <AppFooter/>
        </div>
        <div v-else>
            <Login/>
        </div>
        <notifications :duration="1500" style="font-size: medium"/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    import AppHeader from "./components/layout/AppHeader";
    import AppFooter from "./components/layout/AppFooter";
    import Login from "./pages/Auth/Login";

    export default {

        components: {
            AppFooter,
            AppHeader,
            Login
        },
        computed: {
            ...mapGetters("auth", ["isAuthenticated"]),
        },
    }

</script>
<style>
    #app {
        font-family: Poppins;
    }

    .app-main {
        padding: 1.5rem;
    }

    .table {
        width: 100%;
    }

    .table td {
        border: 0px;
    }

    .vue-notification-group {
        top: 25px;
        right: 25px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .15s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .modified-table {
        overflow-y: scroll;
        max-height: 650px;
    }

    .modified-table thead th {
        color: white;
        background-color: #56759c;
        font-style: normal;
        font-size: 15px;
        top: -1px;
        position: sticky;
        z-index: 2;
        font-family: Helvetica, Arial;
    }

    .modified-table td {
        border: 0px;
        font-size: 16px;
        font-family: Helvetica, Arial;
        text-align: center;
    }

    .modified-table th {
        top: -12px;
        positiairports-tableon: sticky;
        background-color: white;
        z-index: 2;
        text-align: center;
    }

    ::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #292961
    }

    .modified-font-1 {
        font-family: ui-sans-serif;
    }

    .button-hover:hover {
        box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
        transform: scale(1.00);
    }

    .modified-button {
        background-color: #1e3e67;
        color: white;
        max-height: 36px;
        max-width: 300px;
    }

    .modified-color-blue {
        color: #1e3e67;
    }

    .modified-color-red {
        color: #ec2929d4;
    }

    .modified-button:hover {
            box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
        transform: scale(1.00);
        color: white;

    }
    .modal-card-head {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
    .modal-card-foot {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;

    }
    .dashboard-border span{
      font-family: Helvetica, Arial;
      font-size: 18px;
      color: #383838;
      font-weight: 500;
    }
    .dashboard-border{
      padding:10px;
      box-shadow: 0px 3px 10px #ced4da;
    }
    .modal-footer span{
      color: #ffffff;
      font-family: Helvetica,Arial;
      font-weight: unset;
    }
    .modal-header{
      background-color: #eff1f3;
    }
    .modal-footer{
      background-color: #eff1f3;
    }
    @media (max-width: 767px) {
      .dashboard-border span{
        font-size: 16px;
      }
      .modified-table thead th {
        font-size: 14px;
      }
      .modified-table td {
        font-size: 14px;
      }

    }

</style>

